import { STATS_FAILURE, STATS_PENDING, STATS_SUCCESS } from "../../actions/types";

const initialState = {
  loading: false,
  data: {
    activeEmployees: 0,
    totalVisitProfiles: 0,
    totalDoctors: 0,
    totalPracticeLocations: 0,
  },
  error: null,
};

const statsReducer = (state = initialState, action) => {
  switch (action.type) {
    case STATS_PENDING:
      return { ...state, loading: true, error: null };
      
    case STATS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
      
    case STATS_FAILURE:
      return { ...state, loading: false, error: action.payload };
      
    default:
      return state;
  }
};

export default statsReducer;
